import { Modal } from '@bp/ui-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ClassesForm } from '../Forms/ClassesForm';

type ClassesModalProps = {
  classUuid: string | null;
  isOpen: boolean;
  onClose: () => void;
};

export const ClassesModal = ({ classUuid, isOpen, onClose }: ClassesModalProps) => {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  return (
    <Modal
      isOpen={isOpen}
      loading={isLoading}
      onRequestClose={onClose}
      title={classUuid ? t('classes.editClass') : t('classes.createClass')}
    >
      <ClassesForm classUuid={classUuid} onLoad={setIsLoading} onClose={onClose} />
    </Modal>
  );
};
